import React from 'react';
import Funnel, {
    Title,
    Margin,
    Export,
    Tooltip,
    Item,
    Border,
    Label,
  } from 'devextreme-react/funnel';
import 'devextreme/dist/css/dx.light.css';


const TFFunnel = ( { data, w, h, title, legend } ) => {
    function formatLabel(arg) {
        return `<span class="label">${arg.percentText}</span><br/>${arg.item.argument}`;
    }

    return (
        <div className='text-center' style={ { width: w ? w : '100%', height: h ? h : '100%' } }>
            <Funnel id="funnel"
                dataSource={data}
                palette="Soft Pastel"
                argumentField="milestone"
                valueField="total"
            >
                {/* <Title text={ title }>
                    <Margin bottom={30} />
                </Title>
                <Export enabled={true} /> */}
                <Tooltip enabled={true} format="fixedPoint" />
                <Item>
                    <Border visible={true} />
                </Item>
                <Label
                    visible={true}
                    backgroundColor="none"
                    customizeText={formatLabel}
                    showForZeroValues={true}
                />
            </Funnel>
        </div>
    )
}

export default TFFunnel;

